module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_8003.a821cbd8.png";